import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row, Input, FormGroup, Label } from "reactstrap";
import { Modal } from "react-bootstrap";
import ReactRoundedImage from "react-rounded-image";
import FolsomLogo from "../../../../assets/img/FolsomLogo.png";
import Swal from "sweetalert2";
import countryList from "react-select-country-list";
import { Country, State, City } from "country-state-city";

import NumberFormat from "react-number-format";
import Select from "react-select";
import { CheckClosingYearD } from "../../../../views/Forms/ShortFunction/CheckClosingYearD";
// import "../formsTable.css";
// import "../baseForms.css";
import SelfEmployeeInfo from "../selfEmployeeInfo";
import EmployeeInfo from "../employeeInfo";

// import "./myReactSelect.css";
import swal from "@sweetalert/with-react";
import { baseurl } from "../../../../baseurl";
import { Link } from "react-router-dom";
import axios from "axios";
import { checkPermission } from "../../../../Helper";
import { GetIp } from "../../../../views/Forms/ShortCutComponents/Get_ip";
import ReactDatePicker from "../../../../views/Forms/ShortCutComponents/ReactDatePicker";
import ResponseLoader from "../../../../views/Forms/ShortCutComponents/ResponseLoader";
import SelectorCountry from "../../../../views/Forms/ShortCutComponents/selector_country";
import moment from "moment";

const username = localStorage.getItem("username");
const token = localStorage.getItem("token");
const companyId = localStorage.getItem("companyId");
const companyCurrency = localStorage.getItem("companySymbolCurrency");

export default function LeaveApplication(props) {
  const [resignTypeLov, setResignTypeLov] = useState([]);
  const [loadingResponce, setLoadingResponce] = useState(true);
  const [disableField, setDisableField] = useState(false);
  const [ipCountry, setIpCountry] = useState(false);
  const [showPropModal, setShowPropModal] = useState(false);
  const [file, setFile] = useState(null);
  const [imageUrl, setImageUrl] = useState();

  const [masterData, setMasterData] = useState({
    // isOpenPartyModel: false,
    // isOpenBankModel: false,
    nod: null,
    lastWorkingDate: new Date(),
    gender: props.location.state?.gender,
    lName: null,
    nationality: { value: "PK", label: "Pakistan" },
    applicationNo: "",
    highEducation: null,
    status: null,
    noticePeriodDays: 444,
    numberOfInstalment: 15,
    designation: null,
    resignType: null,
    resignReason: null,
    shift: null,
    department: null,
    sickLeave: null,
    specialization: null,
    certification: null,
    prevEmp: null,
    cpl: null,
    role: null,
    tempAddress: null,
    tempCity: null,
    permanentAddress: null,
    annualLeave: null,
    total: null,
    salaryGroup: null,
    institute: null,
    code: "",
    remarks: "",
    toDate: new Date(),
    restDayProfile: null,
    passPort: "",
    date: new Date(),
    workLocation: null,
    permanentCity: null,
    dueDate: new Date(),

    // cashBank: null,
    // instrumentTypeId: null,
    // instrumentDate: null,
    // instrumNo: null,
    // mtRemarks: "",
    // totalCost: 0,
    // account_id: null,
  });
  const [totalSizes, setTotalSizes] = useState();
  const [formValues, setFormValues] = useState({
    country: null,
    state: null,
    city: null,
  });

  const countries = Country.getAllCountries();
  const updatedCountries = countries.map((country) => ({
    label: country.name,
    value: country.isoCode,
    ...country,
  }));

  const updatedStates = (countryCode) =>
    State.getStatesOfCountry(countryCode).map((state) => ({
      label: state.name,
      value: state.isoCode,
      ...state,
    }));

  const updatedCities = (countryCode, stateCode) =>
    City.getCitiesOfState(countryCode, stateCode).map((city) => ({
      label: city.name,
      value: city.name,
      ...city,
    }));

  const handleChange = (name, value) => {
    console.log("hello", name, value);
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
      ...(name === "country" && { state: null, city: null }),
      ...(name === "state" && { city: null }),
    }));
  };

  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);

  const countries2 = Country.getAllCountries().map((country) => ({
    label: country.name,
    value: country.isoCode,
  }));

  const states = selectedCountry
    ? State.getStatesOfCountry(selectedCountry.value).map((state) => ({
        label: state.name,
        value: state.isoCode,
      }))
    : [];

  const cities = selectedState
    ? City.getCitiesOfState(selectedCountry.value, selectedState.value).map(
        (city) => ({
          label: city.name,
          value: city.name,
        })
      )
    : [];

  const masterInputEvent = (e, pName) => {
    console.log("gggg>", e);
    if (pName === "gender") {
      setMasterData({
        ...masterData,
        gender: e,
        // institute: null,
        // sickLeave: null,
        // specialization: null,
        // prevEmp: null,
        // cpl: null,
        // role: null,
        // tempAddress: null,
        // tempCity: null,
      });
    } else if (pName === "lName") {
      setMasterData({ ...masterData, lName: e });
    } else if (pName === "nationality") {
      // let partyId = e?.id;
      console.log("gggg11>", e);
      setMasterData({ ...masterData, nationality: e });
    } else if (pName === "designation") {
      setMasterData({ ...masterData, designation: e });
    } else if (pName === "resignType") {
      setMasterData({
        ...masterData,
        resignType: e,
      });
    } else if (pName === "resignReason") {
      setMasterData({
        ...masterData,
        resignReason: e,
      });
    } else if (pName === "shift") {
      setMasterData({
        ...masterData,
        shift: e,
        // department: e,
        // department: e?.SKU_color || "",
        // lName: e?.item_type_id_desc || "",
        // code: e?.making_notes || "",
      });
    } else if (pName === "department") {
      setMasterData({ ...masterData, department: e });
    } else if (pName === "restDayProfile") {
      setMasterData({ ...masterData, restDayProfile: e });
    } else if (pName === "workLocation") {
      setMasterData({ ...masterData, workLocation: e });
    } else if (pName === "permanentCity") {
      setMasterData({ ...masterData, permanentCity: e });
    } else if (pName === "salaryGroup") {
      setMasterData({ ...masterData, salaryGroup: e });
    } else if (pName === "tempCity") {
      setMasterData({ ...masterData, tempCity: e });
    } else if (pName === "permanentCity") {
      setMasterData({ ...masterData, permanentCity: e });
    } else {
      const value = e.target.value;
      const name = e.target.name;
      console.log(value, name);

      setMasterData({ ...masterData, [name]: value });
    }
  };
  // Function to calculate sum
  const calculateSum = () => {
    const {
      sickLeave,
      specialization,
      prevEmp,
      cpl,
      role,
      tempAddress,
      tempCity,
    } = masterData;
    let addSizes =
      sickLeave * 1 +
      specialization * 1 +
      prevEmp * 1 +
      cpl * 1 +
      role * 1 +
      tempAddress * 1 +
      tempCity * 1;
    console.log("addSizes1", addSizes);
    setTotalSizes(addSizes);
    setMasterData({
      ...masterData,
      institute: addSizes,
    });
  };

  const stringToNumber = (str) => {
    let newValue = 0;
    if (str) {
      newValue = Number(str?.toString()?.replaceAll(",", ""));
    }

    return newValue;
  };
  const extractNumbersFromString = (str) => {
    const numbersOnly = str.replace(/\D/g, ""); // Remove all non-digit characters
    return numbersOnly;
  };

  const getLovs = () => {
    setLoadingResponce(true);
    axios
      .post(
        `${baseurl}/PayRoll/getEmpLovs`,
        {
          companyId: companyId,
          username: username,
          check: 1, //1= regular tables , 2= extended
          tables: ["resignType"],
        },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((response) => {
        setLoadingResponce(false);
        const responseData = response.data;
        let { resignType } = responseData;

        setResignTypeLov(resignType);
      })
      .catch((err) => {
        setLoadingResponce(false);
        console.log(err);
      });
  };

  const checkDateOfYear = async (e) => {
    var lastWorkingDate;
    let byDefault;
    if (e === "did") {
      byDefault = "didMount";
      lastWorkingDate = masterData.lastWorkingDate;
    } else {
      byDefault = "";
      lastWorkingDate = e;
    }

    const tableName = "one_order_mt";
    const invoiceType = 1;
    const invBookId = 39;
    const dateColumn = "order_date";
    const documentNo = "order_no";
    var date = moment(lastWorkingDate).format("YYYY-MM-DD");

    let closeDate = await CheckClosingYearD(
      date,
      tableName,
      invoiceType,
      invBookId,
      dateColumn,
      documentNo,
      byDefault
    );
    var docNo = closeDate[1];

    if (closeDate[0] === true) {
      setMasterData({
        ...masterData,
        lastWorkingDate: "",
        nod: "",
      });
    } else if (closeDate[0] === false) {
      setMasterData({
        ...masterData,
        lastWorkingDate: lastWorkingDate,
        nod: docNo,
      });
    } else {
      setMasterData({
        ...masterData,
        lastWorkingDate: "",
        nod: "",
      });
    }
  };
  let updateCheck =
    props.location.state?.type || props.location.state?.updateCheck;

  const asyncRollCheck = async (value) => {
    let pathname = "/addResignApplication";
    let status = value;

    let hasPermission = await checkPermission(pathname, status);
    if (hasPermission) {
      return true;
    }
  };

  useEffect(() => {
    const funCall = async (value) => {
      await asyncRollCheck(value);
    };
    funCall(0);
    console.log("aaaa", props);
    let id = props.location.state?.rowData?.id || props.location.state?.id;
    console.log("aaaa", id, updateCheck);
    getLovs();

    if (updateCheck === 1) {
      setDisableField(true);
      getPaymentEntryById(id, updateCheck);
    } else if (updateCheck === 2) {
      getPaymentEntryById(id, updateCheck);
    } else {
      // checkDateOfYear("did");
    }

    // if (updateCheck !== 1) getIpCountry();
  }, []);

  const getUserIp = async function () {
    let res = await GetIp();
    return {
      userIp: res.ip,
      userCountry: res.country,
    };
  };
  const checkNullObject = (objId, objLabel) => {
    return objId ? { id: objId, label: objLabel } : null;
  };
  const getPaymentEntryById = (id, updateCheck) => {
    setLoadingResponce(true);
    axios
      .post(
        `${baseurl}/PayRoll/getResignApplicationById`,
        {
          companyId: companyId,
          username: username,
          id: id,
        },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((res) => {
        setLoadingResponce(false);

        let responseData = res.data.data[0];
        const {
          number_of_days,
          resign_date,
          resign_type_id,
          resign_type_desc,
          amount,
          no_of_inst,
          remarks,
          to_date,
        } = responseData;

        console.log("aaa", responseData);

        setMasterData({
          ...masterData,
          masterId: id,
          updateCheck: updateCheck,
          // nod: number_of_days,
          lastWorkingDate: new Date(resign_date), //------------------------------checker
          resignType: checkNullObject(resign_type_id, resign_type_desc),
          // resignReason: checkNullObject(adv_type_id, adv_type_desc),
          status: amount,
          // noticePeriodDays: amount,
          numberOfInstalment: no_of_inst,
          remarks: remarks,
          // toDate: new Date(to_date), //------------------------------checker
        });
      })
      .catch((err) => {
        console.log(err);
        setLoadingResponce(false);
      });
  };
  // const getIpCountry = async () => {
  //   let { userIp, userCountry } = await getUserIp();
  //   setIpCountry({ userIp, userCountry });
  // };
  const handleSubmit = async (event) => {
    console.log("Data???", masterData);
    event.preventDefault();
    setLoadingResponce(true);
    const {
      gender,
      nod,
      // lastWorkingDate,
      lName,
      nationality,
      applicationNo,
      highEducation,
      status,
      noticePeriodDays,
      numberOfInstalment,
      designation,
      resignType,
      resignReason,
      shift,
      department,
      sickLeave,
      specialization,
      certification,
      prevEmp,
      cpl,
      role,
      tempAddress,
      tempCity,
      total,
      salaryGroup,
      institute,
      code,
      remarks,
      restDayProfile,
      passPort,
      // date,
      workLocation,
      permanentCity,
      permanentAddress,
      annualLeave,
      // dueDate,
      // toDate,
      masterId,
    } = masterData;
    var companyId = localStorage.getItem("companyId");
    let toDate = moment(masterData.toDate).format("YYYY-MM-DD");
    let lastWorkingDate = moment(masterData.lastWorkingDate).format(
      "YYYY-MM-DD"
    );

    // let { userIp, userCountry } = await ipCountry;

    if (masterId > -1) {
      // let Id = props.EditData;
      axios
        .post(
          `${baseurl}/PayRoll/updateResignApplication`,
          {
            id: masterId,
            companyId,
            // applicationNo: applicationNo,
            // lName: lName,
            lastWorkingDate: lastWorkingDate,
            // nod: nod,
            // passPort: passPort,
            status: status,
            noticePeriodDays: noticePeriodDays,
            numberOfInstalment: numberOfInstalment,
            // gender: gender.id,
            // nationality: nationality.label,
            // toDate: toDate,
            resignType: resignType.id,
            resignReason: resignReason.id,
            // department: department.id,
            // designation: designation.id,
            // salaryGroup: salaryGroup.id,
            // restDayProfile: restDayProfile.id,
            // workLocation: workLocation?.id,
            // highEducation: highEducation,
            // institute: institute,
            // sickLeave: sickLeave,
            // specialization: specialization,
            // certification: certification,
            // prevEmp: prevEmp,
            // cpl: cpl,
            // role: role,
            // tempAddress: tempAddress,
            // tempCity: tempCity.id,
            // permanentAddress: permanentAddress,
            // permanentCity: permanentCity.id,
            // annualLeave: annualLeave,
            // code: code,
            remarks: remarks,

            username: username,
            // userIp,
            // userCountry,
          },
          {
            headers: {
              authorization: token,
            },
          }
        )

        .then(function (response) {
          setLoadingResponce(false);
          setDisableField(true);
          setMasterData({
            ...masterData,
            nod: response.data.latestDocNo,
          });
          swal({
            title: "Saved Successfully!",
            text: "Resign Application Updated",
            icon: "success",
          }).then((value) => {});
        })
        .catch(function (error) {
          console.log(error);
          setLoadingResponce(false);

          swal({
            title: "Error",
            text: "Something went wrong, try to refresh the page and try again.",
            icon: "error",
          });
        });
    } else {
      axios
        .post(
          `${baseurl}/PayRoll/addResignApplication`,
          {
            companyId,
            // applicationNo: applicationNo,
            // lName: lName,
            lastWorkingDate: lastWorkingDate,
            // nod: nod,
            // passPort: passPort,
            status: status,
            noticePeriodDays: noticePeriodDays,
            numberOfInstalment: numberOfInstalment,
            // gender: gender.id,
            // nationality: nationality.label,
            // toDate: toDate,
            resignType: resignType.id,
            resignReason: resignReason.id,
            // department: department.id,
            // designation: designation.id,
            // salaryGroup: salaryGroup.id,
            // restDayProfile: restDayProfile.id,
            // workLocation: workLocation?.id,
            // highEducation: highEducation,
            // institute: institute,
            // sickLeave: sickLeave,
            // specialization: specialization,
            // certification: certification,
            // prevEmp: prevEmp,
            // cpl: cpl,
            // role: role,
            // tempAddress: tempAddress,
            // tempCity: tempCity.id,
            // permanentAddress: permanentAddress,
            // permanentCity: permanentCity.id,
            // annualLeave: annualLeave,
            // code: code,
            remarks: remarks,

            username: username,
            // userIp,
            // userCountry,
          },
          {
            headers: {
              authorization: token,
            },
          }
        )
        .then(function (res) {
          setLoadingResponce(false);
          setDisableField(true);
          setMasterData({ ...masterData, nod: res.data.latestDocNo });

          const id = res.data?.id;

          swal({
            title: "Saved Successfully!",
            text: "Resign Application Added",
            icon: "success",
          }).then((value) => {});
        })
        .catch(function (error) {
          console.log("erooor", error);
          setLoadingResponce(false);

          swal({
            title: "Error",
            text: "Something went wrong, try to refresh the page and try again.",
            icon: "error",
          });
        });
    }
  };
  return (
    <>
      {loadingResponce === true ? (
        <ResponseLoader />
      ) : (
        <div>
          <Row className="Creative-Invoice-header-styling">
            <Col specialization="8" className="card-header-Creative-Invoice">
              <>
                <strong>
                  <h4>
                    {updateCheck === 1
                      ? " preview "
                      : updateCheck === 2
                      ? "Update "
                      : "Add "}{" "}
                    Resign Application
                  </h4>
                </strong>
              </>
            </Col>
            <Col specialization="4" className="card-header-Creative-Invoice">
              <div
                style={{
                  textAlign: "right",
                }}
              >
                <Link
                  to="/resignApplicationOverview"
                  style={{
                    fontFamily: "Times New Roman",
                    fontWeight: "normal",
                    margin: "10px",
                  }}
                >
                  <u className="Back-to-Overview">Back to Overview</u>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    className="bi bi-chevron-left mx-2 icon-color"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                    />
                  </svg>
                </Link>
              </div>
            </Col>
          </Row>

          <Row className="rowStyling">
            <Col>
              <div className="row">
                <div className="col-md-12">
                  <Form name="simpleForm" onSubmit={handleSubmit}>
                    <SelfEmployeeInfo />
                    {/* <EmployeeInfo /> */}
                    <div className="row">
                      {" "}
                      <div className="col-4" style={{ marginBottom: "12px" }}>
                        <Label>
                          Resign Type:
                          <span style={{ color: "tomato" }}>*</span>
                        </Label>

                        <Select
                          options={resignTypeLov}
                          onChange={(e) => masterInputEvent(e, "resignType")}
                          value={masterData.resignType}
                          id="resignType"
                          name="resignType"
                          required
                          isClearable
                          placeholder={"-- Select --"}
                          isDisabled={disableField ? true : false}
                        />
                      </div>
                      <div className="col-4" style={{ marginBottom: "12px" }}>
                        <Label>
                          Resign Reason:
                          <span style={{ color: "tomato" }}>*</span>
                        </Label>

                        <Select
                          options={resignTypeLov}
                          onChange={(e) => masterInputEvent(e, "resignReason")}
                          value={masterData.resignReason}
                          id="resignReason"
                          name="resignReason"
                          required
                          isClearable
                          placeholder={"-- Select --"}
                          isDisabled={disableField ? true : false}
                        />
                      </div>
                      <div className="col-4" style={{ marginBottom: "12px" }}>
                        <Label style={{ fontWeight: "bold" }}>
                          Status:
                          <span style={{ color: "tomato" }}>*</span>
                        </Label>

                        <Input
                          type="text"
                          className="form-control"
                          name="status"
                          id="status"
                          required
                          onChange={(e) => masterInputEvent(e)}
                          value={masterData.status}
                          disabled={disableField ? true : false}
                          autoComplete="off"
                        />
                      </div>
                      <div className="col-4" style={{ marginBottom: "12px" }}>
                        <Label style={{ fontWeight: "bold" }}>
                          Notice Period (Days):
                          <span style={{ color: "tomato" }}>*</span>
                        </Label>

                        <Input
                          type="number"
                          className="form-control"
                          name="noticePeriodDays"
                          id="noticePeriodDays"
                          required
                          onChange={(e) => masterInputEvent(e)}
                          value={masterData.noticePeriodDays}
                          disabled
                          autoComplete="off"
                        />
                      </div>
                      {/* <div className="col-4" style={{ marginBottom: "12px" }}>
                        <Label style={{ fontWeight: "bold" }}>
                          No of Installment:
                          <span style={{ color: "tomato" }}>*</span>
                        </Label>

                        <Input
                          type="number"
                          className="form-control"
                          name="numberOfInstalment"
                          id="numberOfInstalment"
                          required
                          onChange={(e) => masterInputEvent(e)}
                          value={masterData.numberOfInstalment}
                          disabled
                          autoComplete="off"
                        />
                      </div> */}
                      <ReactDatePicker
                        label="Last Working Date:"
                        className=" col-md-4  col-lg-4 col-xl-4  col-4"
                        isSelected={masterData.lastWorkingDate}
                        onChange={(e) => {
                          setMasterData({ ...masterData, lastWorkingDate: e });
                        }}
                        // onChange={(e) => {
                        //   console.log(
                        //     "e>>>masterData.lastWorkingDate:",
                        //     masterData.lastWorkingDate
                        //   );
                        //   console.log("e>>>:", e);
                        //   const timeDifference =
                        //     new Date(masterData.toDate) - new Date(e);
                        //   const daysDifference =
                        //     timeDifference / (1000 * 60 * 60 * 24);
                        //   setMasterData({
                        //     ...masterData,
                        //     lastWorkingDate: e,
                        //     nod: Math.round(daysDifference),
                        //   });
                        // }}
                        isDisabled={disableField ? true : false}
                        // maxDate={masterData.toDate}
                      />{" "}
                      {/* <ReactDatePicker
                        label="To Date:"
                        className="col-md-4  col-lg-4 col-xl-4 col-4"
                        isSelected={masterData.toDate}
                        onChange={(e) => {
                          console.log(
                            "e>>>masterData.lastWorkingDate:",
                            masterData.lastWorkingDate
                          );
                          console.log("e>>>:", e);
                          const timeDifference =
                            new Date(e) - new Date(masterData.lastWorkingDate);
                          const daysDifference =
                            timeDifference / (1000 * 60 * 60 * 24);
                          setMasterData({
                            ...masterData,
                            toDate: e,
                            nod: Math.round(daysDifference),
                          });
                        }}
                        isDisabled={disableField ? true : false}
                        minDate={masterData.lastWorkingDate}
                      /> */}
                      {/* <div className="col-4" style={{ marginBottom: "12px" }}>
                        <Label style={{ fontWeight: "bold" }}>
                          No of Days:
                          <span style={{ color: "tomato" }}>*</span>
                        </Label>

                        <Input
                          type="text"
                          className="form-control"
                          name="nod"
                          id="nod"
                          onChange={(e) => masterInputEvent(e)}
                          value={masterData.nod}
                          required
                          autoComplete="off"
                          disabled
                        />
                      </div> */}
                      <div className="col-8" style={{ marginBottom: "12px" }}>
                        <Label style={{ fontWeight: "bold" }}>
                          Remarks:
                          {/* <span style={{ color: "tomato" }}> *</span> */}
                        </Label>

                        <Input
                          type="textarea"
                          className="form-control"
                          required
                          name="remarks"
                          id="remarks"
                          onChange={(e) => masterInputEvent(e)}
                          value={masterData.remarks}
                          // style={{ height: "90px" }}
                          autoComplete="off"
                          rows={3} // Specify the number of rows
                          // required
                          disabled={disableField ? true : false}
                          placeholder="Enter Your Remarks (Optional)"
                        />
                      </div>
                      {/* <div
                        className="col-md-12"
                        style={{
                          marginBottom: "12px",
                          textAlign: "left",
                          backgroundColor: "#363089",
                          borderRadius: "15px",
                        }}
                      >
                        <Label style={{ color: "white", fontSize: "1.2rem" }}>
                          Resign Balances{" "}
                        </Label>
                      </div> */}
                      {/* {resignTypeLov.map((element, index) => (
                        <div className="col-2" style={{ marginBottom: "12px" }}>
                          <Label style={{ fontWeight: "bold" }}>
                            {element.label}:
                            <span style={{ color: "tomato" }}>*</span>
                          </Label>
                          <Input
                            type="number"
                            className="form-control"
                            required
                            name="cpl"
                            id="cpl"
                            onChange={(e) => masterInputEvent(e)}
                            value={masterData.cpl}
                            autoComplete="off"
                            disabled
                          />
                        </div>
                      ))} */}
                      {/* <div className="col-4" style={{ marginBottom: "12px" }}>
                        <Label style={{ fontWeight: "bold" }}>
                          Resign Against Salary:
                          <span style={{ color: "tomato" }}>*</span>
                        </Label>

                        <Input
                          type="number"
                          className="form-control"
                          name="annualLeave"
                          id="annualLeave"
                          onChange={(e) => masterInputEvent(e)}
                          value={masterData.annualLeave}
                          required
                          autoComplete="off"
                          disabled
                        />
                      </div> */}
                      {/* 
                      <div className="col-2" style={{ marginBottom: "12px" }}>
                        <Label style={{ fontWeight: "bold" }}>
                          Sick Leave:
                          <span style={{ color: "tomato" }}>*</span>
                        </Label>
                        <Input
                          type="number"
                          className="form-control"
                          name="sickLeave"
                          required
                          id="sickLeave"
                          onChange={(e) => masterInputEvent(e)}
                          value={masterData.sickLeave}
                          autoComplete="off"
                          disabled
                        />
                      </div> */}
                    </div>
                    <hr
                      style={{
                        border: "1px solid ",
                        marginBottom: "3vh",
                        marginTop: "3vh",
                        borderColor: "E4E5E6",
                      }}
                    />
                    <FormGroup>
                      <span className="d-flex flex-row-reverse">
                        <Button
                          hidden={masterData.updateCheck === 1}
                          disabled={
                            loadingResponce || disableField ? true : false
                          }
                          className="mr-1 invoiceSubmitButton "
                        >
                          {masterData.updateCheck === 2 ? "Update" : "Save"}{" "}
                          Changes
                        </Button>
                        <Link
                          to={{
                            pathname: "/resignApplicationOverview",
                          }}
                        >
                          <Button className="mr-1" size="sm">
                            Cancel
                          </Button>
                        </Link>
                      </span>
                    </FormGroup>
                  </Form>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      )}
    </>
  );
}
